export const TAXGROUP_SETUP_GET = 'TAXGROUP_SETUP_GET';
export const TAXGROUP_SETUP_ERROR = 'TAXGROUP_SETUP_ERROR';
export const TAXGROUP_SETUP_CLEAR = 'TAXGROUP_SETUP_CLEAR';
export const TAXGROUP_SETUP_LOADING = 'TAXGROUP_SETUP_LOADING';



// WEBPACK FOOTER //
// ./src/pages/inventory/taxgroupsetup/state/types.js